export const getDisplayName = (userData) => {
  userData = userData || {}
  return userData.username || userData.email
}

export const isUserSet = (userData) => {
  return userData && (userData.username || userData.email)
}
